import "./float-menu.scss";
import { disableScroll, enableScroll } from '../../../client/scroll-stop';

(function() {
    init();
})();


function init() {
    const box = document.querySelector('.float-menu');

    if (!box) {
        return;
    }

    const content = box.querySelector('.float-menu__content');
    const button = box.querySelector('.float-menu__button');
    const querySelectorParent = box.getAttribute('data-selector') || 'body';
    const parentElements = document.querySelectorAll(querySelectorParent);
    const [list, counts] = createList(parentElements);

    if (counts > 1) {
        attachWindowScroll(box);
        attachEventList(content);
        attachEventButton(button, content);

        content.append(list);

        box.classList.remove('hidden');
        document.body.appendChild(box);
    }   
}


function attachWindowScroll(box) {
    const footer = document.querySelector('.base__footer');
    const footerRec = footer.getBoundingClientRect();

    window.addEventListener('scroll', function (event) {
        const windowBottom = window.innerHeight + window.scrollY;
        const stopViewMenu = document.body.offsetHeight - footerRec.height;

        box.hidden = windowBottom >= stopViewMenu;
    });
}


function attachEventButton(button, content) {
    button.addEventListener('click', event => {
        content.classList.toggle('_show');

        if (content.classList.contains('_show')) {
            disableScroll();
        } else {
            enableScroll();
        }
    });
}

function attachEventList(content) {
    content.addEventListener('click', event => {
        const element = event.target;

        if (!element.classList.contains('float-menu__item')) {
            return;
        }

        if (element._ref) {
            element._ref.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
        } else {
            document.body.scrollIntoView({
                behavior: "smooth",
                block: "start"
            })
        }

        content.classList.remove('_show');
        enableScroll();
    });
}

function createList(parents) {
    const frag = document.createDocumentFragment();
    let counts = 0;

    parents.forEach(item => {
        const items = item.querySelectorAll('h1, h2, h3, h4');

        if (items.length) {
            counts += items.length;
            frag.appendChild(
                createItems(items)
            );
        }
    });

    return [frag, counts];
}

function createItems(items) {
    const ul = document.createElement('ul');

    items.forEach(item => {
        ul.appendChild(
            createElement(item.innerText, item.tagName.toLocaleLowerCase(), item)
        )
    });

    return ul;
}

function createElement(value, clsPostfix='default', ref=null) {
    const element = document.createElement('li');
    element._ref = ref;
    element.className = `float-menu__item _${clsPostfix}`;
    element.appendChild(document.createTextNode(value));
    return element;
}
